import React from 'react';
import { createPortal } from 'react-dom';
import './Spinner.css';
import { loader } from '../../assets/jss/style';

export default () => createPortal(<div style={{ top: '50%', position: 'fixed' }} className={`spinner-container ${loader}`}>
  <div className="spinner" />
</div>, document.body);
